import { render, staticRenderFns } from "./smallSort.vue?vue&type=template&id=574b62c0&scoped=true"
import script from "./smallSort.vue?vue&type=script&lang=js"
export * from "./smallSort.vue?vue&type=script&lang=js"
import style0 from "./smallSort.vue?vue&type=style&index=0&id=574b62c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574b62c0",
  null
  
)

export default component.exports